import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ButtonCard} from '../../card/button-card';
import {LinkCard} from '../../card/link-card';

import {ThumbnailContent} from '../thumbnail-content/thumbnail-content';
import type {Props as ThumbnailContentProps} from '../thumbnail-content/thumbnail-content';

type Props = ThumbnailContentProps & {
    isSelected?: boolean;
    isDisabled?: boolean;
    showDisabledOverlay?: boolean;
    onClick?: () => void;
    to?: string;
    href?: string;
};

export function ThumbnailButtonCard(props: Props) {
    const {
        href,
        to,
        onClick,
        isSelected,
        isDisabled,
        showDisabledOverlay,
        ...thumbnailContentProps
    } = props;

    return (
        <>
            {to || href ? (
                <LinkCard
                    // @ts-expect-error
                    as={to ? RoutedLink : undefined}
                    to={to}
                    href={href}
                    preventUnderline={true}
                >
                    <ThumbnailContent {...thumbnailContentProps} />
                </LinkCard>
            ) : (
                <ButtonCard
                    onClick={onClick}
                    isSelected={isSelected}
                    isDisabled={isDisabled}
                    isFullWidth={true}
                    fitHeight={true}
                    showDisabledOverlay={showDisabledOverlay}
                >
                    <ThumbnailContent {...thumbnailContentProps} />
                </ButtonCard>
            )}
        </>
    );
}
